import { render, staticRenderFns } from "./FuneralNotice.vue?vue&type=template&id=265596b6&scoped=true&"
import script from "./FuneralNotice.vue?vue&type=script&lang=js&"
export * from "./FuneralNotice.vue?vue&type=script&lang=js&"
import style0 from "./FuneralNotice.vue?vue&type=style&index=0&id=265596b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265596b6",
  null
  
)

export default component.exports